import { FC, ReactNode } from 'react';
import './config';

export const I18nProvider: FC<{ children: ReactNode }> = ({ children }) => (
  <>{children}</>
);
